import tillFilter from '@js/store/modules/till-filter';
import Auth from '@js/plugins/auth';
import { mapActions } from 'vuex';

export default {
    data() {
        let that = this;

        return {
            mode: 'buttons',

            preSelectOperator: true,

            returnOperatorValueList: true,

            externalRemotes: {
                closure(query) {
                    return that
                        .getTillClosureListIfNecessary({
                            outlet_id: that.activeOutlet,
                            since: that.since,
                            until: that.until,
                            query,
                        })
                        .then(data => {
                            return data.map(d => ({
                                id: d.id,
                                display_name: d.sequence_number,
                                owner_outlets: that.ownerOutlets,
                                outlet_name: d.outlet_name,
                                staff_name: d.staff_name,
                            }));
                        });
                },

                summary(query) {
                    return that
                        .getTillSummaryListIfNecessary({
                            outlet_id: that.activeOutlet,
                            since: that.since,
                            until: that.until,
                            query,
                        })
                        .then(data => {
                            return data.map(d => ({
                                id: d.id,
                                display_name: d.sequence_number,
                                owner_outlets: that.ownerOutlets,
                                outlet_name: d.outlet_name,
                                staff_name: d.staff_name,
                            }));
                        });
                },
            },
        };
    },

    computed: {
        loading() {
            return this.onLoading('get-tillmeta');
        },

        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },

        since() {
            return this.$store.getters.startDate.format();
        },

        until() {
            return this.$store.getters.endDate.format();
        },

        ownerOutlets() {
            return (
                this.activeOutlet == 0 &&
                (Auth.outlets().length == 0 || Auth.outlets().length > 1)
            );
        },
    },

    created() {
        if (!this.$store.hasModule('tillFilter')) {
            this.$store.registerModule('tillFilter', tillFilter);
        }
    },

    methods: {
        ...mapActions('tillFilter', [
            'getTillClosureListIfNecessary',
            'getTillSummaryListIfNecessary',
        ]),
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/till-filter/till-filter-mixin.js